import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';

import rootState from './modules/rootState';
import featureShare from './modules/featureShare';
import WorkflowFinder from './modules/WorkflowFinderModule';
import RecommendedWorkflows from './modules/RecommendedWorkflowsModule';

import workflow from './modules/workflow';
import restoreWorkflow from './modules/restoreWorkflow';
import wfRules from './modules/wfRules';
import tour from './modules/tour';
import tags from './modules/tags'
import watchRules from './plugins/watch-rules.js';
import customerPrices from './modules/customerPrices.js'

import {setStore} from './StoreInstance';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: { featureShare, workflow, restoreWorkflow, wfRules, WorkflowFinder, RecommendedWorkflows, tour,tags, customerPrices },
  plugins: [watchRules],
  ...rootState(router)
});

setStore(store);

export default store;
